import React, { useState } from 'react'
import Navbar from '../Components/Navbar'
import MainSlider from '../Components/MainSlider'
import ResidentialProperties from '../Components/ResidentialProperties'
import Footer from '../Components/Footer'
import CommercialProperties from '../Components/CommercialProperties'
import AllTestimonial from '../Components/AllTestimonial'
import AllDeveloper from '../Components/AllDeveloper'
import FloatingForm from '../Components/FloatingForm'
import PopularePlaces from '../Components/PopularePlaces'
import WhatsAppButton from '../Components/WhatsAppButton'


function Home() {

    const [Name, setName] = useState('');
    const [Location, setLocation] = useState('');

    return (
        <>
            <Navbar />
            <MainSlider Name={Name} setName={setName} Location={Location} setLocation={setLocation} />
            <FloatingForm />
            <br />
            <br />
            <br />
            <ResidentialProperties Name={Name} Location={Location} />
            <br />
            <br />
            <CommercialProperties Name={Name} Location={Location} />
            <br />
            <br />
            <AllTestimonial />
            <br />
            <br />
            <br />
            <br />
            <AllDeveloper />
            <br />
            <br />
            <br />
            <br />
            <PopularePlaces />
            <br />
            <br />
            <WhatsAppButton />
            <Footer />
        </>
    )
}

export default Home